import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { LANG_SELECTION_MAP, BASE_URL } from 'src/constants'

export default () => {
  const domain = BASE_URL.slice(-1) === '/' ? BASE_URL.slice(0, -1) : BASE_URL
  return (
    <span className="language_selection">
      {LANG_SELECTION_MAP.map((lang, idx) => (
        <React.Fragment key={uuidv4()}>
          {idx > 0 ? <span className="slice"> / </span> : undefined}
          {domain === lang.domain ? (
            <span key={uuidv4()}>{lang.label}</span>
          ) : (
            <a href={lang.domain} key={uuidv4()}>
              {lang.label}
            </a>
          )}
        </React.Fragment>
      ))}
    </span>
  )
}
